import React from 'react';
import { StyledExternalIcon, StyledHiddenA11yText } from './ExternalIcon.styles';

const ExternalIcon = ({ isExternal, children }) => {
    if (!isExternal) {
        return <span>{children}</span>;
    }

    return (
        <>
            <StyledExternalIcon aria-hidden="true" />
            {children}
            <StyledHiddenA11yText>, öppnar annan webbplats</StyledHiddenA11yText>
        </>
    );
};

export default ExternalIcon;
